import { ColorShades } from './colorShades.enum';

export const ColorShadesScale =
[ ColorShades.CS100, ColorShades.CS200, ColorShades.CS300, ColorShades.CS500, ColorShades.CS700, ColorShades.CS900 ];
